import ProgramType from 'src/types/programType';
import { ProgramConfig } from 'src/types/programConfig';

/** Shared config for GFC and GFC-EU banners to avoid drift */
const gfcBaseConfig = {
  labels: {
    productGroup: 'Temp Zone',
    category: 'Drop Zone',
    subcategory: 'Velocity',
    itemIdentifierType: 'ASIN' as const,
  },
  zoneMapBehavior: {
    requireAllFixturesAssigned: true,
    requireDepartmentForProductFlow: false,
    supportsDepartmentFilter: false,
    customPickPathNumbering: true,
    productFlowLabel: 'pick path',
  },
  macroplanogramScope: 'category' as const,
};

export const programRegistry: Record<ProgramType, ProgramConfig> = {
  [ProgramType.WholeFoods]: {
    programType: ProgramType.WholeFoods,
    routePrefix: '/wholefoods',
    labels: {
      productGroup: 'Product Group',
      category: 'Category',
      subcategory: 'Subcategory',
      itemIdentifierType: 'Scancode',
    },
    features: {
      zoneMap: { productFlow: true },
      itemAssortment: { mode: 'scancode' },
      assortmentSearch: {},
      multiStoreCopy: {},
      recommendations: { source: 'rules' },
      bulkUpload: { mode: 'csv' },
    },
    zoneMapBehavior: {
      requireAllFixturesAssigned: false,
      requireDepartmentForProductFlow: true,
      supportsDepartmentFilter: true,
      customPickPathNumbering: false,
      productFlowLabel: 'product flow',
    },
    macroplanogramScope: 'subcategory',
    navPaths: [
      { name: 'Product Group', url: 'productGroups' },
      { name: 'Zone Map', url: 'zoneCreation' },
      { name: 'Agile Merchandising', url: 'agileManagement' },
    ],
  },
  [ProgramType.Gfc]: {
    ...gfcBaseConfig,
    programType: ProgramType.Gfc,
    routePrefix: '/gfc',
    features: {
      // Pick path drawing persists to Floor Plan Service (per-fixture pickPathId)
      // via useUpdateFloorplan.
      zoneMap: { productFlow: true, floorplanPicker: true },
      itemAssortment: { mode: 'scancode', scope: 'category' },
      capacityValidation: {},
      extraDimension: { required: true, label: 'Sub Drop Zone' },
    },
    navPaths: [
      { name: 'Product Group', url: 'productGroups' },
      { name: 'Zone Map', url: 'zoneCreation' },
      { name: 'Agile Merchandising', url: 'agileManagement' },
    ],
  },
  [ProgramType.GfcEu]: {
    ...gfcBaseConfig,
    programType: ProgramType.GfcEu,
    routePrefix: '/gfceu',
    features: {
      itemAssortment: { mode: 'asin' },
      extraDimension: { required: true, label: 'Sub Drop Zone' },
    },
    navPaths: [{ name: 'Product Group', url: 'productGroups' }],
  },
  [ProgramType.GfcJp]: {
    ...gfcBaseConfig,
    programType: ProgramType.GfcJp,
    routePrefix: '/gfcjp',
    features: {
      itemAssortment: { mode: 'asin' },
      extraDimension: { required: true, label: 'Sub Drop Zone' },
    },
    navPaths: [{ name: 'Product Group', url: 'productGroups' }],
  },
  [ProgramType.Ssd]: {
    ...gfcBaseConfig,
    programType: ProgramType.Ssd,
    routePrefix: '/ssd',
    features: {
      itemAssortment: { mode: 'asin' },
      extraDimension: { required: true, label: 'Sub Drop Zone' },
    },
    navPaths: [{ name: 'Product Group', url: 'productGroups' }],
  },
  [ProgramType.QuickCommerce]: {
    ...gfcBaseConfig,
    programType: ProgramType.QuickCommerce,
    routePrefix: '/qc',
    features: {
      itemAssortment: { mode: 'asin' },
      extraDimension: { required: true, label: 'Sub Drop Zone' },
    },
    navPaths: [{ name: 'Product Group', url: 'productGroups' }],
  },
  [ProgramType.Go]: {
    programType: ProgramType.Go,
    routePrefix: '/go',
    labels: {
      productGroup: 'Product Group',
      category: 'Category',
      subcategory: 'Subcategory',
      itemIdentifierType: 'ASIN',
    },
    features: {
      productReadiness: {},
    },
    zoneMapBehavior: {
      requireAllFixturesAssigned: false,
      requireDepartmentForProductFlow: false,
      supportsDepartmentFilter: false,
      customPickPathNumbering: false,
      productFlowLabel: 'product flow',
    },
    macroplanogramScope: 'subcategory',
    navPaths: [{ name: 'Product Readiness', url: 'productReadiness' }],
  },
};
